const KEY_PREFIX = 'workspace-sidebar-enabled:'

export const workspaceSidebarStorageKey = (orgUuid: string) => `${KEY_PREFIX}${orgUuid}`

/**
 * `localStorage.clear()` that keeps the per-org workspace sidebar memory, so switching org or
 * logging back in opens straight into the right sidebar instead of the old one until flags load.
 */
export const clearLocalStorageKeepingWorkspaceSidebar = () => {
  const kept: [string, string][] = []
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i)
    const value = key?.startsWith(KEY_PREFIX) ? localStorage.getItem(key) : null
    if (key && value !== null) kept.push([key, value])
  }
  localStorage.clear()
  for (const [key, value] of kept) localStorage.setItem(key, value)
}
